(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kids-product-card"] && !Shopify.designMode) return;
  try {
    // This block is intentionally duplicated from product-card.liquid because snippet JavaScript ships only when that snippet renders; the entire duplicate is block-scoped to avoid a global class binding.
  if (!customElements.get("product-card-form")) {
    class ProductCardForm extends HTMLElement {
      constructor() {
        super();
        this.defaultImageData = null;
      }
  
      connectedCallback() {
        // Wait for next tick to allow DOM manipulation to complete
        setTimeout(() => {
          this.initializeComponent();
        }, 0);
      }
  
      initializeComponent() {
        // Find elements after the component is connected to DOM and content is moved
        this.selector = this.querySelector('.variant-selector');
        this.trigger = this.querySelector('.variant-selector__trigger');
        this.label = this.querySelector('.variant-selector__label');
        this.labelText = this.trigger?.querySelector('.variant-selector__label-text');
        this.labelColor = this.trigger?.querySelector('.variant-selector__label-color');
        this.labelTags = this.trigger?.querySelector('.variant-selector__label-tags');
        this.optionsContainer = this.querySelector('.variant-selector__options');
        this.options = this.querySelectorAll('.variant-selector__option');
  
        // Get the product card and image element
        this.productCard = this.closest('.product-card');
  
        // Find the default image (variant changes only affect the default image)
        const imageLink = this.productCard?.querySelector('.product-card__image');
        this.productImage = imageLink?.querySelector('.product-card__image-img--default');
  
        if (!this.productImage) {
          // Fallback: look for any img inside the image link (for backward compatibility)
          this.productImage = imageLink?.querySelector('img');
        }
  
        this.form = this.productCard?.querySelector('.product-card__form');
        this.variantInput = this.productCard?.querySelector('.variant-id-input');
        this.submitButton = this.form?.querySelector('[data-product-submit]');
        this.waitlistButton = this.form?.querySelector('[data-waitlist-trigger]');
  
        if (this.productImage) {
          this.defaultImageData = this.getImageDataFromElement(this.productImage);
        } else {
          console.warn('ProductCardForm: Product image not found');
        }
  
        // Price elements live on the product card outside the wrapper
        this.priceWrapper = this.productCard?.querySelector('[data-price-wrapper]');
        this.priceElement = this.priceWrapper?.querySelector('[data-product-price]');
        this.compareElement = this.priceWrapper?.querySelector('[data-compare-price]');
        this.servingElement = this.productCard?.querySelector('[data-serving-price]');
        if (this.servingElement && !this.servingElement.dataset.originalText) {
          this.servingElement.dataset.originalText = this.servingElement.textContent.trim();
        }
  
        // Quantity selector elements
        this.quantitySelector = this.querySelector('.product-card__quantity-selector');
        this.quantityInput = this.quantitySelector?.querySelector('.quantity-input');
        this.quantityMinusBtn = this.quantitySelector?.querySelector('.quantity-btn--minus');
        this.quantityPlusBtn = this.quantitySelector?.querySelector('.quantity-btn--plus');
  
        // B2B total price target (card price)
        const cardRoot = this.closest('.product-card');
        this.cardPriceEl = cardRoot?.querySelector('[data-role="product-card-price"]');
        this.b2b = cardRoot?.getAttribute('data-b2b') === 'true';
  
        this.isOpen = false;
        const selectedOptionIndex = Array.from(this.options).findIndex(
          (option) => option.getAttribute('aria-selected') === 'true'
        );
        this.activeOptionIndex = selectedOptionIndex >= 0 ? selectedOptionIndex : 0;
  
        this.init();
      }
  
      init() {
        // Handle variant selector if it exists
        if (this.selector && this.options.length > 0) {
          // Handle trigger click
          this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
          this.trigger.addEventListener('keydown', this.handleTriggerKeydown.bind(this));
  
          // Handle option selection
          this.options.forEach((option, index) => {
            option.addEventListener('click', () => this.handleOptionSelect(index));
            option.addEventListener('keydown', (event) => this.handleOptionKeydown(event, index));
          });
  
          // Handle click outside to close
          document.addEventListener('click', this.handleOutsideClick.bind(this));
        }
  
        // Handle form submission (always attach if form exists)
        if (this.form) {
          this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        }
  
        const selectedOption = this.options[this.activeOptionIndex];
        if (selectedOption) {
          window.EquipProductWaitlist?.updateProductWaitlistState(this, selectedOption);
        }
  
        // Handle quantity selector if it exists
        if (this.quantitySelector && this.quantityInput) {
          this.quantityMinusBtn?.addEventListener('click', this.handleQuantityDecrease.bind(this));
          this.quantityPlusBtn?.addEventListener('click', this.handleQuantityIncrease.bind(this));
          this.quantityInput.addEventListener('change', this.handleQuantityChange.bind(this));
          this.quantityInput.addEventListener('input', this.validateQuantity.bind(this));
  
          // Initialize button states
          this.updateQuantityButtons();
          // Initialize B2B caps and total
          if (this.b2b) {
            if (this.selector && this.options && this.options.length > 0) {
              // Enforce cap based on initially selected option
              const initiallySelected =
                Array.from(this.options).find((o) => o.getAttribute('aria-selected') === 'true') || this.options[0];
              if (initiallySelected) this.enforceInventoryCap(initiallySelected);
            } else {
              // Single-variant products: enforce using input data attributes
              this.enforceInventoryCapFromInput();
            }
            this.updateB2BTotal();
          }
        }
      }
  
      handleTriggerClick() {
        this.toggleDropdown();
      }
  
      handleTriggerKeydown(event) {
        const { key } = event;
  
        switch (key) {
          case 'Enter':
          case ' ':
          case 'ArrowDown':
            event.preventDefault();
            this.openDropdown();
            this.focusOption(this.activeOptionIndex);
            break;
          case 'ArrowUp':
            event.preventDefault();
            this.openDropdown();
            this.focusOption(this.options.length - 1);
            break;
        }
      }
  
      handleOptionSelect(index) {
        this.activeOptionIndex = index;
        const option = this.options[index];
        this.updateSelectedOption(option);
        this.closeDropdown();
        this.trigger.focus();
  
        // Emit custom event for external listeners
        this.dispatchEvent(
          new CustomEvent('variant:change', {
            detail: {
              variantId: option.dataset.variantId,
              price: option.dataset.variantPrice,
              title: option.querySelector('.variant-selector__option-title').textContent.trim(),
            },
            bubbles: true,
          })
        );
  
        // Recompute B2B total and inventory cap
        if (this.b2b) {
          this.enforceInventoryCap(option);
          this.updateB2BTotal();
        }
      }
  
      handleOptionKeydown(event, index) {
        const { key } = event;
  
        switch (key) {
          case 'ArrowDown':
            event.preventDefault();
            const nextIndex = (index + 1) % this.options.length;
            this.focusOption(nextIndex);
            break;
          case 'ArrowUp':
            event.preventDefault();
            const prevIndex = index === 0 ? this.options.length - 1 : index - 1;
            this.focusOption(prevIndex);
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            this.handleOptionSelect(index);
            break;
          case 'Escape':
            event.preventDefault();
            this.closeDropdown();
            this.trigger.focus();
            break;
        }
      }
  
      handleOutsideClick(event) {
        if (!this.contains(event.target) && this.isOpen) {
          this.closeDropdown();
        }
      }
  
      toggleDropdown() {
        if (this.isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }
  
      openDropdown() {
        if (this.isOpen) return;
  
        this.isOpen = true;
        this.selector.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
  
        // Enable keyboard navigation for options
        this.options.forEach((option, index) => {
          option.tabIndex = index === this.activeOptionIndex ? 0 : -1;
        });
      }
  
      closeDropdown() {
        if (!this.isOpen) return;
  
        this.isOpen = false;
        this.selector.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
  
        // Disable keyboard navigation for options
        this.options.forEach((option) => {
          option.tabIndex = -1;
        });
      }
  
      focusOption(index) {
        if (index < 0 || index >= this.options.length) return;
  
        this.activeOptionIndex = index;
        this.options.forEach((option, i) => {
          option.tabIndex = i === index ? 0 : -1;
        });
        this.options[index].focus();
      }
  
      handleQuantityDecrease() {
        if (!this.quantityInput) return;
  
        const currentValue = parseInt(this.quantityInput.value) || 1;
        const step = parseInt(this.quantityMinusBtn.dataset.change) || -1;
        const min = parseInt(this.quantityInput.min) || 1;
  
        const newValue = Math.max(min, currentValue + step);
        this.quantityInput.value = newValue;
        this.updateQuantityButtons();
        if (this.b2b) this.updateB2BTotal();
      }
  
      handleQuantityIncrease() {
        if (!this.quantityInput) return;
  
        const currentValue = parseInt(this.quantityInput.value) || 1;
        const step = parseInt(this.quantityPlusBtn.dataset.change) || 1;
        const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;
  
        const newValue = max ? Math.min(max, currentValue + step) : currentValue + step;
        this.quantityInput.value = newValue;
        this.updateQuantityButtons();
        if (this.b2b) this.updateB2BTotal();
      }
  
      handleQuantityChange() {
        this.validateQuantity();
        this.updateQuantityButtons();
        if (this.b2b) this.updateB2BTotal();
      }
  
      validateQuantity() {
        if (!this.quantityInput) return;
  
        const value = parseInt(this.quantityInput.value) || 1;
        const min = parseInt(this.quantityInput.min) || 1;
        const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;
  
        let validValue = Math.max(min, value);
        if (max) {
          validValue = Math.min(max, validValue);
        }
  
        if (value !== validValue) {
          this.quantityInput.value = validValue;
        }
      }
  
      updateQuantityButtons() {
        if (!this.quantityInput || !this.quantityMinusBtn || !this.quantityPlusBtn) return;
  
        const currentValue = parseInt(this.quantityInput.value) || 1;
        const min = parseInt(this.quantityInput.min) || 1;
        const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;
  
        // Update minus button state
        this.quantityMinusBtn.disabled = currentValue <= min;
  
        // Update plus button state
        this.quantityPlusBtn.disabled = max ? currentValue >= max : false;
      }
  
      async handleFormSubmit(event) {
        event.preventDefault();
  
        if (!this.variantInput || !this.submitButton) {
          return;
        }
  
        const variantId = this.variantInput.value;
        const quantity = this.quantityInput ? this.quantityInput.value : '1';
  
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
  
        // Show loading state
        const originalText = this.submitButton.innerHTML;
        this.submitButton.innerHTML = 'Adding...';
        this.submitButton.disabled = true;
  
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          });
  
          if (response.ok) {
            const cart = await response.json();
  
            // Show success state briefly
            this.submitButton.innerHTML = 'Added!';
  
            // Emit cart update event
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: { cart },
              })
            );
  
            // Reset button after 1.5 seconds
            setTimeout(() => {
              this.submitButton.innerHTML = originalText;
              this.submitButton.disabled = false;
            }, 1500);
          } else {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to add to cart');
          }
        } catch (error) {
          this.submitButton.innerHTML = 'Error - Try Again';
  
          setTimeout(() => {
            this.submitButton.innerHTML = originalText;
            this.submitButton.disabled = false;
          }, 2000);
        }
      }
  
      updateSelectedOption(selectedOption) {
        // Update aria-selected states
        this.options.forEach((option) => {
          option.setAttribute('aria-selected', option === selectedOption ? 'true' : 'false');
        });
  
        // Update trigger label
        const optionTitleEl = selectedOption.querySelector('.variant-selector__option-title');
        const title = optionTitleEl?.textContent.trim() || '';
        if (this.labelText) {
          this.labelText.textContent = title;
        } else if (this.label) {
          this.label.textContent = title;
        }
  
        if (this.labelColor) {
          const colorValue = selectedOption.dataset.variantColor;
          if (colorValue) {
            this.labelColor.style.setProperty('--variant-color', colorValue);
            this.labelColor.hidden = false;
          } else {
            this.labelColor.hidden = true;
            this.labelColor.style.removeProperty('--variant-color');
          }
        }
  
        if (this.labelTags) {
          const tagsSource = selectedOption.querySelector('.variant-selector__option-tags');
          const hasTags = tagsSource && tagsSource.innerHTML.trim().length > 0 && !tagsSource.hasAttribute('hidden');
          if (hasTags) {
            this.labelTags.innerHTML = tagsSource.innerHTML;
            this.labelTags.hidden = false;
          } else {
            this.labelTags.innerHTML = '';
            this.labelTags.hidden = true;
          }
        }
  
        // Update form variant ID
        if (this.variantInput) {
          this.variantInput.value = selectedOption.dataset.variantId;
        }
  
        window.EquipProductWaitlist?.updateProductWaitlistState(this, selectedOption);
  
        // Update product image if variant has a different image
        if (this.productImage) {
          const variantImageData = this.getImageDataFromOption(selectedOption, title);
          if (variantImageData && variantImageData.src) {
            this.setProductImageData(variantImageData);
          } else if (this.defaultImageData) {
            this.setProductImageData(this.defaultImageData);
          }
        }
  
        this.updatePriceUI(selectedOption);
  
        // Update B2B price on card if present
        if (this.b2b) this.updateB2BTotal();
      }
  
      updatePriceUI(option) {
        if (!option) return;
  
        const priceInCents = parseInt(option.dataset.variantPrice || '0', 10);
        const priceOriginalInCents = parseInt(option.dataset.variantPriceOriginal || priceInCents, 10);
        const compareInCents = parseInt(option.dataset.variantComparePrice || '0', 10);
        const servingCount = parseInt(option.dataset.variantServingCount || '0', 10);
  
        // Get sale settings from product card
        const saleEnabled = this.productCard?.dataset.saleEnabled === 'true';
        const saleDiscount = parseInt(this.productCard?.dataset.saleDiscount || '0', 10);
  
        // data-variant-price now contains the already-discounted sale price
        // data-variant-price-original contains the original price
        let displayPrice = priceInCents;
        let displayComparePrice = compareInCents;
  
        if (saleEnabled && saleDiscount > 0) {
          // Use the sale price that was already calculated in Liquid
          displayPrice = priceInCents; // Already discounted
          displayComparePrice = priceOriginalInCents; // Show original as strikethrough
        }
  
        if (this.priceElement) {
          this.priceElement.textContent = this.formatCurrency(displayPrice);
        }
  
        if (this.compareElement) {
          const hasCompare = saleEnabled ? true : compareInCents > priceInCents;
          this.compareElement.toggleAttribute('hidden', !hasCompare);
          if (hasCompare) {
            this.compareElement.textContent = this.formatCurrency(displayComparePrice);
          }
        }
  
        if (this.servingElement) {
          if (servingCount > 0 && displayPrice > 0) {
            const perServingAmount = Math.floor(displayPrice / servingCount);
            const formatted = this.formatCurrency(perServingAmount, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            this.servingElement.textContent = `${formatted} per serving`;
            this.servingElement.removeAttribute('hidden');
          } else if (this.servingElement.dataset.originalText) {
            this.servingElement.textContent = this.servingElement.dataset.originalText;
          }
        }
      }
  
      getImageDataFromOption(option, fallbackAlt = '') {
        if (!option) return null;
        const { variantImageSrc, variantImageSrcset, variantImageAlt, variantImageId } = option.dataset;
        if (!variantImageSrc) return null;
        return {
          src: variantImageSrc,
          srcset: variantImageSrcset || '',
          alt: variantImageAlt || fallbackAlt,
          imageId: variantImageId || '',
        };
      }
  
      getImageDataFromElement(img) {
        if (!img) return null;
        return {
          src: img.getAttribute('src') || '',
          srcset: img.getAttribute('srcset') || '',
          alt: img.getAttribute('alt') || '',
          imageId: img.dataset.imageId || '',
        };
      }
  
      setProductImageData({ src, srcset, alt, imageId }) {
        // Re-query the default image element in case DOM has changed
        const imageLink = this.productCard?.querySelector('.product-card__image');
        const img = imageLink?.querySelector('.product-card__image-img--default') || this.productImage;
  
        if (!img) {
          console.warn('ProductCardForm: Cannot update image - element not found');
          return;
        }
  
        if (src) {
          img.setAttribute('src', src);
          img.src = src;
        }
  
        if (srcset) {
          img.setAttribute('srcset', srcset);
          img.srcset = srcset;
        } else {
          img.removeAttribute('srcset');
          img.srcset = '';
        }
  
        const finalAlt = alt || this.defaultImageData?.alt || '';
        if (finalAlt) {
          img.setAttribute('alt', finalAlt);
          img.alt = finalAlt;
        } else {
          img.removeAttribute('alt');
        }
  
        if (imageId) {
          img.setAttribute('data-image-id', imageId);
        } else {
          img.removeAttribute('data-image-id');
        }
      }
  
      disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick.bind(this));
      }
  
      // Helpers: B2B total using quantity breaks
      getVariantBreakData(variantId) {
        const container = this.closest('.product-card')?.querySelector('.product-card__variant-price-data');
        if (!container) return { priceCents: 0, breaks: [] };
        const node = container.querySelector(`[data-variant-id="${variantId}"]`);
        if (!node) return { priceCents: 0, breaks: [] };
        const priceCents = parseInt(node.getAttribute('data-price-cents') || '0', 10);
        const spans = node.querySelectorAll('.break');
        const breaks = [];
        spans.forEach((el) => {
          const min = parseInt(el.getAttribute('data-minimum-quantity') || '0', 10);
          const p = parseInt(el.getAttribute('data-price') || '0', 10);
          if (min > 0 && p > 0) breaks.push({ minimum_quantity: min, price_cents: p });
        });
        breaks.sort((a, b) => a.minimum_quantity - b.minimum_quantity);
        return { priceCents, breaks };
      }
  
      formatCurrency(cents, overrides = {}) {
        try {
          const currency = this.closest('.product-card')?.getAttribute('data-currency') || 'USD';
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
            ...overrides,
          }).format((cents || 0) / 100);
        } catch (_) {
          return `$${((cents || 0) / 100).toFixed(2)}`;
        }
      }
  
      updateB2BTotal() {
        if (!this.cardPriceEl) return;
        const variantId = this.variantInput?.value || this.options?.[this.activeOptionIndex]?.dataset.variantId;
        if (!variantId) return;
        const qty = parseInt(this.quantityInput?.value || '1', 10) || 1;
        const data = this.getVariantBreakData(variantId);
        let unit = data.priceCents;
        if (data.breaks.length > 0) {
          const applicable = data.breaks.filter((b) => qty >= b.minimum_quantity && b.price_cents > 0);
          if (applicable.length > 0) unit = applicable[applicable.length - 1].price_cents;
        }
  
        // Apply sale discount if enabled
        const saleEnabled = this.productCard?.dataset.saleEnabled === 'true';
        const saleDiscount = parseInt(this.productCard?.dataset.saleDiscount || '0', 10);
        if (saleEnabled && saleDiscount > 0) {
          const discountMultiplier = (100 - saleDiscount) * 0.01;
          unit = Math.floor(unit * discountMultiplier);
        }
  
        const total = unit * qty;
        this.cardPriceEl.textContent = this.formatCurrency(total);
      }
  
      enforceInventoryCap(selectedOption) {
        const invQty = parseInt(selectedOption?.dataset.variantInventoryQuantity || '0', 10);
        const invPolicy = (selectedOption?.dataset.variantInventoryPolicy || '').toLowerCase();
        const qtyInput = this.quantityInput;
        if (!qtyInput) return;
        const increment = parseInt(qtyInput.step || '1', 10) || 1;
        let hardMax = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
        if (invPolicy === 'deny' && invQty > 0) {
          const maxByInv = Math.floor(invQty / increment) * increment;
          hardMax = hardMax == null ? maxByInv : Math.min(hardMax, maxByInv);
        }
        if (hardMax != null && hardMax > 0) {
          qtyInput.max = String(hardMax);
          const cur = parseInt(qtyInput.value || '1', 10) || 1;
          if (cur > hardMax) qtyInput.value = String(hardMax);
        } else {
          qtyInput.removeAttribute('max');
        }
        this.updateQuantityButtons();
      }
  
      enforceInventoryCapFromInput() {
        const qtyInput = this.quantityInput;
        if (!qtyInput) return;
        const invQty = parseInt(qtyInput.getAttribute('data-inventory-quantity') || '0', 10);
        const invPolicy = (qtyInput.getAttribute('data-inventory-policy') || '').toLowerCase();
        const increment = parseInt(qtyInput.step || '1', 10) || 1;
        let hardMax = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
        if (invPolicy === 'deny' && invQty > 0) {
          const maxByInv = Math.floor(invQty / increment) * increment;
          hardMax = hardMax == null ? maxByInv : Math.min(hardMax, maxByInv);
        }
        if (hardMax != null && hardMax > 0) {
          qtyInput.max = String(hardMax);
          const cur = parseInt(qtyInput.value || '1', 10) || 1;
          if (cur > hardMax) qtyInput.value = String(hardMax);
        } else {
          qtyInput.removeAttribute('max');
        }
        this.updateQuantityButtons();
      }
    }
  
    // Register the custom element within the outer guard
    customElements.define('product-card-form', ProductCardForm);
  
    // Initialize product card forms when DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
      // Find all product cards with form functionality enabled
      const productCards = document.querySelectorAll('.product-card');
  
      productCards.forEach((card) => {
        const form = card.querySelector('.product-card__form');
        const variants = card.querySelector('.product-card__variants');
        const priceGroup = card.querySelector('[data-product-price-group]');
  
        // Only wrap if there's a form (indicating form functionality is enabled)
        if (form && !form.closest('product-card-form')) {
          const wrapper = document.createElement('product-card-form');
  
          // Insert wrapper before the form
          form.parentNode.insertBefore(wrapper, form);
  
          // Move variant selector into wrapper first (if it exists)
          if (variants) {
            wrapper.appendChild(variants);
          }
  
          // Move price group so it sits between variants and form
          if (priceGroup) {
            wrapper.appendChild(priceGroup);
          }
  
          // Move form into wrapper last (so button stays at bottom)
          wrapper.appendChild(form);
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductCardForm extends HTMLElement {
    constructor() {
      super();
      this.defaultImageData = null;
    }

    connectedCallback() {
      // Wait for next tick to allow DOM manipulation to complete
      setTimeout(() => {
        this.initializeComponent();
      }, 0);
    }

    initializeComponent() {
      // Find elements after the component is connected to DOM and content is moved
      this.selector = this.querySelector('.variant-selector');
      this.trigger = this.querySelector('.variant-selector__trigger');
      this.label = this.querySelector('.variant-selector__label');
      this.labelText = this.trigger?.querySelector('.variant-selector__label-text');
      this.labelColor = this.trigger?.querySelector('.variant-selector__label-color');
      this.labelTags = this.trigger?.querySelector('.variant-selector__label-tags');
      this.optionsContainer = this.querySelector('.variant-selector__options');
      this.options = this.querySelectorAll('.variant-selector__option');

      // Get the product card and image element
      this.productCard = this.closest('.product-card');

      // Find the default image (variant changes only affect the default image)
      const imageLink = this.productCard?.querySelector('.product-card__image');
      this.productImage = imageLink?.querySelector('.product-card__image-img--default');

      if (!this.productImage) {
        // Fallback: look for any img inside the image link (for backward compatibility)
        this.productImage = imageLink?.querySelector('img');
      }

      this.form = this.productCard?.querySelector('.product-card__form');
      this.variantInput = this.productCard?.querySelector('.variant-id-input');
      this.submitButton = this.form?.querySelector('[data-product-submit]');
      this.waitlistButton = this.form?.querySelector('[data-waitlist-trigger]');

      if (this.productImage) {
        this.defaultImageData = this.getImageDataFromElement(this.productImage);
      } else {
        console.warn('ProductCardForm: Product image not found');
      }

      // Price elements live on the product card outside the wrapper
      this.priceWrapper = this.productCard?.querySelector('[data-price-wrapper]');
      this.priceElement = this.priceWrapper?.querySelector('[data-product-price]');
      this.compareElement = this.priceWrapper?.querySelector('[data-compare-price]');
      this.servingElement = this.productCard?.querySelector('[data-serving-price]');
      if (this.servingElement && !this.servingElement.dataset.originalText) {
        this.servingElement.dataset.originalText = this.servingElement.textContent.trim();
      }

      // Quantity selector elements
      this.quantitySelector = this.querySelector('.product-card__quantity-selector');
      this.quantityInput = this.quantitySelector?.querySelector('.quantity-input');
      this.quantityMinusBtn = this.quantitySelector?.querySelector('.quantity-btn--minus');
      this.quantityPlusBtn = this.quantitySelector?.querySelector('.quantity-btn--plus');

      // B2B total price target (card price)
      const cardRoot = this.closest('.product-card');
      this.cardPriceEl = cardRoot?.querySelector('[data-role="product-card-price"]');
      this.b2b = cardRoot?.getAttribute('data-b2b') === 'true';

      this.isOpen = false;
      const selectedOptionIndex = Array.from(this.options).findIndex(
        (option) => option.getAttribute('aria-selected') === 'true'
      );
      this.activeOptionIndex = selectedOptionIndex >= 0 ? selectedOptionIndex : 0;

      this.init();
    }

    init() {
      // Handle variant selector if it exists
      if (this.selector && this.options.length > 0) {
        // Handle trigger click
        this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
        this.trigger.addEventListener('keydown', this.handleTriggerKeydown.bind(this));

        // Handle option selection
        this.options.forEach((option, index) => {
          option.addEventListener('click', () => this.handleOptionSelect(index));
          option.addEventListener('keydown', (event) => this.handleOptionKeydown(event, index));
        });

        // Handle click outside to close
        document.addEventListener('click', this.handleOutsideClick.bind(this));
      }

      // Handle form submission (always attach if form exists)
      if (this.form) {
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
      }

      const selectedOption = this.options[this.activeOptionIndex];
      if (selectedOption) {
        window.EquipProductWaitlist?.updateProductWaitlistState(this, selectedOption);
      }

      // Handle quantity selector if it exists
      if (this.quantitySelector && this.quantityInput) {
        this.quantityMinusBtn?.addEventListener('click', this.handleQuantityDecrease.bind(this));
        this.quantityPlusBtn?.addEventListener('click', this.handleQuantityIncrease.bind(this));
        this.quantityInput.addEventListener('change', this.handleQuantityChange.bind(this));
        this.quantityInput.addEventListener('input', this.validateQuantity.bind(this));

        // Initialize button states
        this.updateQuantityButtons();
        // Initialize B2B caps and total
        if (this.b2b) {
          if (this.selector && this.options && this.options.length > 0) {
            // Enforce cap based on initially selected option
            const initiallySelected =
              Array.from(this.options).find((o) => o.getAttribute('aria-selected') === 'true') || this.options[0];
            if (initiallySelected) this.enforceInventoryCap(initiallySelected);
          } else {
            // Single-variant products: enforce using input data attributes
            this.enforceInventoryCapFromInput();
          }
          this.updateB2BTotal();
        }
      }
    }

    handleTriggerClick() {
      this.toggleDropdown();
    }

    handleTriggerKeydown(event) {
      const { key } = event;

      switch (key) {
        case 'Enter':
        case ' ':
        case 'ArrowDown':
          event.preventDefault();
          this.openDropdown();
          this.focusOption(this.activeOptionIndex);
          break;
        case 'ArrowUp':
          event.preventDefault();
          this.openDropdown();
          this.focusOption(this.options.length - 1);
          break;
      }
    }

    handleOptionSelect(index) {
      this.activeOptionIndex = index;
      const option = this.options[index];
      this.updateSelectedOption(option);
      this.closeDropdown();
      this.trigger.focus();

      // Emit custom event for external listeners
      this.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: {
            variantId: option.dataset.variantId,
            price: option.dataset.variantPrice,
            title: option.querySelector('.variant-selector__option-title').textContent.trim(),
          },
          bubbles: true,
        })
      );

      // Recompute B2B total and inventory cap
      if (this.b2b) {
        this.enforceInventoryCap(option);
        this.updateB2BTotal();
      }
    }

    handleOptionKeydown(event, index) {
      const { key } = event;

      switch (key) {
        case 'ArrowDown':
          event.preventDefault();
          const nextIndex = (index + 1) % this.options.length;
          this.focusOption(nextIndex);
          break;
        case 'ArrowUp':
          event.preventDefault();
          const prevIndex = index === 0 ? this.options.length - 1 : index - 1;
          this.focusOption(prevIndex);
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.handleOptionSelect(index);
          break;
        case 'Escape':
          event.preventDefault();
          this.closeDropdown();
          this.trigger.focus();
          break;
      }
    }

    handleOutsideClick(event) {
      if (!this.contains(event.target) && this.isOpen) {
        this.closeDropdown();
      }
    }

    toggleDropdown() {
      if (this.isOpen) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (this.isOpen) return;

      this.isOpen = true;
      this.selector.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');

      // Enable keyboard navigation for options
      this.options.forEach((option, index) => {
        option.tabIndex = index === this.activeOptionIndex ? 0 : -1;
      });
    }

    closeDropdown() {
      if (!this.isOpen) return;

      this.isOpen = false;
      this.selector.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');

      // Disable keyboard navigation for options
      this.options.forEach((option) => {
        option.tabIndex = -1;
      });
    }

    focusOption(index) {
      if (index < 0 || index >= this.options.length) return;

      this.activeOptionIndex = index;
      this.options.forEach((option, i) => {
        option.tabIndex = i === index ? 0 : -1;
      });
      this.options[index].focus();
    }

    handleQuantityDecrease() {
      if (!this.quantityInput) return;

      const currentValue = parseInt(this.quantityInput.value) || 1;
      const step = parseInt(this.quantityMinusBtn.dataset.change) || -1;
      const min = parseInt(this.quantityInput.min) || 1;

      const newValue = Math.max(min, currentValue + step);
      this.quantityInput.value = newValue;
      this.updateQuantityButtons();
      if (this.b2b) this.updateB2BTotal();
    }

    handleQuantityIncrease() {
      if (!this.quantityInput) return;

      const currentValue = parseInt(this.quantityInput.value) || 1;
      const step = parseInt(this.quantityPlusBtn.dataset.change) || 1;
      const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;

      const newValue = max ? Math.min(max, currentValue + step) : currentValue + step;
      this.quantityInput.value = newValue;
      this.updateQuantityButtons();
      if (this.b2b) this.updateB2BTotal();
    }

    handleQuantityChange() {
      this.validateQuantity();
      this.updateQuantityButtons();
      if (this.b2b) this.updateB2BTotal();
    }

    validateQuantity() {
      if (!this.quantityInput) return;

      const value = parseInt(this.quantityInput.value) || 1;
      const min = parseInt(this.quantityInput.min) || 1;
      const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;

      let validValue = Math.max(min, value);
      if (max) {
        validValue = Math.min(max, validValue);
      }

      if (value !== validValue) {
        this.quantityInput.value = validValue;
      }
    }

    updateQuantityButtons() {
      if (!this.quantityInput || !this.quantityMinusBtn || !this.quantityPlusBtn) return;

      const currentValue = parseInt(this.quantityInput.value) || 1;
      const min = parseInt(this.quantityInput.min) || 1;
      const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;

      // Update minus button state
      this.quantityMinusBtn.disabled = currentValue <= min;

      // Update plus button state
      this.quantityPlusBtn.disabled = max ? currentValue >= max : false;
    }

    async handleFormSubmit(event) {
      event.preventDefault();

      if (!this.variantInput || !this.submitButton) {
        return;
      }

      const variantId = this.variantInput.value;
      const quantity = this.quantityInput ? this.quantityInput.value : '1';

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      // Show loading state
      const originalText = this.submitButton.innerHTML;
      this.submitButton.innerHTML = 'Adding...';
      this.submitButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          const cart = await response.json();

          // Show success state briefly
          this.submitButton.innerHTML = 'Added!';

          // Emit cart update event
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { cart },
            })
          );

          // Reset button after 1.5 seconds
          setTimeout(() => {
            this.submitButton.innerHTML = originalText;
            this.submitButton.disabled = false;
          }, 1500);
        } else {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to add to cart');
        }
      } catch (error) {
        this.submitButton.innerHTML = 'Error - Try Again';

        setTimeout(() => {
          this.submitButton.innerHTML = originalText;
          this.submitButton.disabled = false;
        }, 2000);
      }
    }

    updateSelectedOption(selectedOption) {
      // Update aria-selected states
      this.options.forEach((option) => {
        option.setAttribute('aria-selected', option === selectedOption ? 'true' : 'false');
      });

      // Update trigger label
      const optionTitleEl = selectedOption.querySelector('.variant-selector__option-title');
      const title = optionTitleEl?.textContent.trim() || '';
      if (this.labelText) {
        this.labelText.textContent = title;
      } else if (this.label) {
        this.label.textContent = title;
      }

      if (this.labelColor) {
        const colorValue = selectedOption.dataset.variantColor;
        if (colorValue) {
          this.labelColor.style.setProperty('--variant-color', colorValue);
          this.labelColor.hidden = false;
        } else {
          this.labelColor.hidden = true;
          this.labelColor.style.removeProperty('--variant-color');
        }
      }

      if (this.labelTags) {
        const tagsSource = selectedOption.querySelector('.variant-selector__option-tags');
        const hasTags = tagsSource && tagsSource.innerHTML.trim().length > 0 && !tagsSource.hasAttribute('hidden');
        if (hasTags) {
          this.labelTags.innerHTML = tagsSource.innerHTML;
          this.labelTags.hidden = false;
        } else {
          this.labelTags.innerHTML = '';
          this.labelTags.hidden = true;
        }
      }

      // Update form variant ID
      if (this.variantInput) {
        this.variantInput.value = selectedOption.dataset.variantId;
      }

      window.EquipProductWaitlist?.updateProductWaitlistState(this, selectedOption);

      // Update product image if variant has a different image
      if (this.productImage) {
        const variantImageData = this.getImageDataFromOption(selectedOption, title);
        if (variantImageData && variantImageData.src) {
          this.setProductImageData(variantImageData);
        } else if (this.defaultImageData) {
          this.setProductImageData(this.defaultImageData);
        }
      }

      this.updatePriceUI(selectedOption);

      // Update B2B price on card if present
      if (this.b2b) this.updateB2BTotal();
    }

    updatePriceUI(option) {
      if (!option) return;

      const priceInCents = parseInt(option.dataset.variantPrice || '0', 10);
      const priceOriginalInCents = parseInt(option.dataset.variantPriceOriginal || priceInCents, 10);
      const compareInCents = parseInt(option.dataset.variantComparePrice || '0', 10);
      const servingCount = parseInt(option.dataset.variantServingCount || '0', 10);

      // Get sale settings from product card
      const saleEnabled = this.productCard?.dataset.saleEnabled === 'true';
      const saleDiscount = parseInt(this.productCard?.dataset.saleDiscount || '0', 10);

      // data-variant-price now contains the already-discounted sale price
      // data-variant-price-original contains the original price
      let displayPrice = priceInCents;
      let displayComparePrice = compareInCents;

      if (saleEnabled && saleDiscount > 0) {
        // Use the sale price that was already calculated in Liquid
        displayPrice = priceInCents; // Already discounted
        displayComparePrice = priceOriginalInCents; // Show original as strikethrough
      }

      if (this.priceElement) {
        this.priceElement.textContent = this.formatCurrency(displayPrice);
      }

      if (this.compareElement) {
        const hasCompare = saleEnabled ? true : compareInCents > priceInCents;
        this.compareElement.toggleAttribute('hidden', !hasCompare);
        if (hasCompare) {
          this.compareElement.textContent = this.formatCurrency(displayComparePrice);
        }
      }

      if (this.servingElement) {
        if (servingCount > 0 && displayPrice > 0) {
          const perServingAmount = Math.floor(displayPrice / servingCount);
          const formatted = this.formatCurrency(perServingAmount, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.servingElement.textContent = `${formatted} per serving`;
          this.servingElement.removeAttribute('hidden');
        } else if (this.servingElement.dataset.originalText) {
          this.servingElement.textContent = this.servingElement.dataset.originalText;
        }
      }
    }

    getImageDataFromOption(option, fallbackAlt = '') {
      if (!option) return null;
      const { variantImageSrc, variantImageSrcset, variantImageAlt, variantImageId } = option.dataset;
      if (!variantImageSrc) return null;
      return {
        src: variantImageSrc,
        srcset: variantImageSrcset || '',
        alt: variantImageAlt || fallbackAlt,
        imageId: variantImageId || '',
      };
    }

    getImageDataFromElement(img) {
      if (!img) return null;
      return {
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || '',
        alt: img.getAttribute('alt') || '',
        imageId: img.dataset.imageId || '',
      };
    }

    setProductImageData({ src, srcset, alt, imageId }) {
      // Re-query the default image element in case DOM has changed
      const imageLink = this.productCard?.querySelector('.product-card__image');
      const img = imageLink?.querySelector('.product-card__image-img--default') || this.productImage;

      if (!img) {
        console.warn('ProductCardForm: Cannot update image - element not found');
        return;
      }

      if (src) {
        img.setAttribute('src', src);
        img.src = src;
      }

      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.srcset = srcset;
      } else {
        img.removeAttribute('srcset');
        img.srcset = '';
      }

      const finalAlt = alt || this.defaultImageData?.alt || '';
      if (finalAlt) {
        img.setAttribute('alt', finalAlt);
        img.alt = finalAlt;
      } else {
        img.removeAttribute('alt');
      }

      if (imageId) {
        img.setAttribute('data-image-id', imageId);
      } else {
        img.removeAttribute('data-image-id');
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleOutsideClick.bind(this));
    }

    // Helpers: B2B total using quantity breaks
    getVariantBreakData(variantId) {
      const container = this.closest('.product-card')?.querySelector('.product-card__variant-price-data');
      if (!container) return { priceCents: 0, breaks: [] };
      const node = container.querySelector(`[data-variant-id="${variantId}"]`);
      if (!node) return { priceCents: 0, breaks: [] };
      const priceCents = parseInt(node.getAttribute('data-price-cents') || '0', 10);
      const spans = node.querySelectorAll('.break');
      const breaks = [];
      spans.forEach((el) => {
        const min = parseInt(el.getAttribute('data-minimum-quantity') || '0', 10);
        const p = parseInt(el.getAttribute('data-price') || '0', 10);
        if (min > 0 && p > 0) breaks.push({ minimum_quantity: min, price_cents: p });
      });
      breaks.sort((a, b) => a.minimum_quantity - b.minimum_quantity);
      return { priceCents, breaks };
    }

    formatCurrency(cents, overrides = {}) {
      try {
        const currency = this.closest('.product-card')?.getAttribute('data-currency') || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency,
          ...overrides,
        }).format((cents || 0) / 100);
      } catch (_) {
        return `$${((cents || 0) / 100).toFixed(2)}`;
      }
    }

    updateB2BTotal() {
      if (!this.cardPriceEl) return;
      const variantId = this.variantInput?.value || this.options?.[this.activeOptionIndex]?.dataset.variantId;
      if (!variantId) return;
      const qty = parseInt(this.quantityInput?.value || '1', 10) || 1;
      const data = this.getVariantBreakData(variantId);
      let unit = data.priceCents;
      if (data.breaks.length > 0) {
        const applicable = data.breaks.filter((b) => qty >= b.minimum_quantity && b.price_cents > 0);
        if (applicable.length > 0) unit = applicable[applicable.length - 1].price_cents;
      }

      // Apply sale discount if enabled
      const saleEnabled = this.productCard?.dataset.saleEnabled === 'true';
      const saleDiscount = parseInt(this.productCard?.dataset.saleDiscount || '0', 10);
      if (saleEnabled && saleDiscount > 0) {
        const discountMultiplier = (100 - saleDiscount) * 0.01;
        unit = Math.floor(unit * discountMultiplier);
      }

      const total = unit * qty;
      this.cardPriceEl.textContent = this.formatCurrency(total);
    }

    enforceInventoryCap(selectedOption) {
      const invQty = parseInt(selectedOption?.dataset.variantInventoryQuantity || '0', 10);
      const invPolicy = (selectedOption?.dataset.variantInventoryPolicy || '').toLowerCase();
      const qtyInput = this.quantityInput;
      if (!qtyInput) return;
      const increment = parseInt(qtyInput.step || '1', 10) || 1;
      let hardMax = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
      if (invPolicy === 'deny' && invQty > 0) {
        const maxByInv = Math.floor(invQty / increment) * increment;
        hardMax = hardMax == null ? maxByInv : Math.min(hardMax, maxByInv);
      }
      if (hardMax != null && hardMax > 0) {
        qtyInput.max = String(hardMax);
        const cur = parseInt(qtyInput.value || '1', 10) || 1;
        if (cur > hardMax) qtyInput.value = String(hardMax);
      } else {
        qtyInput.removeAttribute('max');
      }
      this.updateQuantityButtons();
    }

    enforceInventoryCapFromInput() {
      const qtyInput = this.quantityInput;
      if (!qtyInput) return;
      const invQty = parseInt(qtyInput.getAttribute('data-inventory-quantity') || '0', 10);
      const invPolicy = (qtyInput.getAttribute('data-inventory-policy') || '').toLowerCase();
      const increment = parseInt(qtyInput.step || '1', 10) || 1;
      let hardMax = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
      if (invPolicy === 'deny' && invQty > 0) {
        const maxByInv = Math.floor(invQty / increment) * increment;
        hardMax = hardMax == null ? maxByInv : Math.min(hardMax, maxByInv);
      }
      if (hardMax != null && hardMax > 0) {
        qtyInput.max = String(hardMax);
        const cur = parseInt(qtyInput.value || '1', 10) || 1;
        if (cur > hardMax) qtyInput.value = String(hardMax);
      } else {
        qtyInput.removeAttribute('max');
      }
      this.updateQuantityButtons();
    }
  }

  // Register the custom element only if it doesn't exist
  if (!customElements.get('product-card-form')) {
    customElements.define('product-card-form', ProductCardForm);
  }

  // Initialize product card forms when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    // Find all product cards with form functionality enabled
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach((card) => {
      const form = card.querySelector('.product-card__form');
      const variants = card.querySelector('.product-card__variants');
      const priceGroup = card.querySelector('[data-product-price-group]');

      // Only wrap if there's a form (indicating form functionality is enabled)
      if (form && !form.closest('product-card-form')) {
        const wrapper = document.createElement('product-card-form');

        // Insert wrapper before the form
        form.parentNode.insertBefore(wrapper, form);

        // Move variant selector into wrapper first (if it exists)
        if (variants) {
          wrapper.appendChild(variants);
        }

        // Move price group so it sits between variants and form
        if (priceGroup) {
          wrapper.appendChild(priceGroup);
        }

        // Move form into wrapper last (so button stays at bottom)
        wrapper.appendChild(form);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
